import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container as RBContainer } from 'rebass';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose, branch, renderComponent } from 'recompose';
import styled from 'styled-components';

import { signUp, login } from '../../Redux/user-profile/actions';
import RegisterForm from '../../Components/RegisterForm';
import ContentWrapper from '../../Components/ContentWrapper';
import { isLogin, isLoading, loginError } from '../../Redux/user-profile/selectors';

const LContainer = styled(RBContainer)`
  min-width: 320px;
  max-width: 440px;
`;
class Register extends Component {
  handleEmailSignUp = async form => {
    await this.props.signUp({ ...form });
  };

  handleFaceBookSignUp = () => {
    this.props.login({ type: 'FACEBOOK' });
  };

  render() {
    const { isLogin, isLoading, error } = this.props;
    const errorCode = error ? error.code : undefined;

    if (isLogin) return <Redirect to={'/dashboard'} />;
    return (
      <ContentWrapper>
        <LContainer>
          <RegisterForm
            loading={isLoading}
            onEmailRegisterClick={this.handleEmailSignUp}
            onFacebookRegisterClick={this.handleFaceBookSignUp}
            errorCode={errorCode}
          />
        </LContainer>
      </ContentWrapper>
    );
  }
}

export default compose(
  connect(
    state => ({
      isLoading: isLoading(state),
      isLogin: isLogin(state),
      error: loginError(state),
    }),
    {
      login,
      signUp,
    },
  ),
  branch(
    props => props.isLogin,
    renderComponent(props => {
      const { from } = props.location.state || { from: { pathname: '/' } };
      return <Redirect to={from} />;
    }),
  ),
)(Register);
